import { _ } from 'oss-toolkits';
export const patchResizeHandler = (resizeCallback, refreshMode, refreshRate, refreshOptions) => {
    switch (refreshMode) {
        case 'debounce':
            return _.debounce(resizeCallback, refreshRate, refreshOptions);
        case 'throttle':
            return _.throttle(resizeCallback, refreshRate, refreshOptions);
        default:
            return resizeCallback;
    }
};
export const isFunction = (fn) => typeof fn === 'function';
export const isSSR = () => typeof window === 'undefined';
export const isDOMElement = (element) => element instanceof Element || element instanceof HTMLDocument;
export const createNotifier = (onResize, setSize, handleWidth, handleHeight) => ({ width, height }) => {
    setSize((prev) => {
        if (prev.width === width && prev.height === height) {
            // skip if dimensions haven't changed
            return prev;
        }
        if ((prev.width === width && !handleHeight) || (prev.height === height && !handleWidth)) {
            // process `handleHeight/handleWidth` props
            return prev;
        }
        if (onResize && isFunction(onResize)) {
            onResize(width, height);
        }
        return { width, height };
    });
};
